import { required, shape } from '@totalsoft/pure-validations';

export const methodValidator = shape({ name: required, typeId: required });
